import {
  findEmployeesSelection,
  removeEmployeesSelection,
  saveEmployeeSelection,
} from "../../infrastructure/employee-selection";

export function selectEmployee({ id, cb }) {
  const allSelected = findEmployeesSelection();

  if (allSelected.includes(id)) {
    saveEmployeeSelection({
      ids: allSelected.filter((s) => s !== id),
    });
  } else {
    saveEmployeeSelection({
      ids: [...allSelected, id],
    });
  }

  if (cb) {
    cb();
  }
}

export function findSelectedEmployees({ of }) {
  const allSelected = findEmployeesSelection();

  return allSelected.filter((id) => of.includes(id));
}

export function selectAllEmployees({ ids, cb }) {
  const currentlySelected = findSelectedEmployees({ of: ids });

  if (currentlySelected.length) {
    removeEmployeesSelection({ ids });
  } else {
    saveEmployeeSelection({ ids });
  }

  if (cb) {
    cb();
  }
}

export function addToSelected({ ids }) {
  const allSelected = findEmployeesSelection();
  const toAdd = ids.filter((id) => !allSelected.includes(id));

  saveEmployeeSelection({
    ids: [...allSelected, ...toAdd],
  });
}
